import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc02d7b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "counter" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "subtitle"
}

import { MinusIcon, PlusIcon } from '@heroicons/vue/24/solid';
import { pluralize } from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberToPurchaseInput',
  setup(__props) {

const store = useClaimStore();

// @dev: setting event.target.value so that the display only shows numbers
const allowOnlyNumbers = (event: any) => {
  const value = event.target.value;
  const newValue = value.replace(/[^0-9]/g, '').replace(/^0+/, '');

  if (newValue === '') {
    store.setTokensToPurchase(1);
    event.target.value = 1;
    return;
  }

  event.target.value = newValue;
  store.setTokensToPurchase(parseInt(newValue));
};

const plusTen = () => {
  store.setTokensToPurchase(store.tokensToPurchase + 10);
};

const setPurchaseToMax = () => {
  store.setTokensToPurchase(store.maxNumberToPurchase);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "circle-button",
          type: "button",
          disabled: _unref(store).tokensToPurchase <= 1,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).decrementTokensToPurchase && _unref(store).decrementTokensToPurchase(...args))),
          "data-testid": "decrement-tokens-button"
        }, [
          _createVNode(_unref(MinusIcon))
        ], 8, _hoisted_3),
        _createElementVNode("input", {
          class: "number-input",
          inputmode: "numeric",
          onInput: allowOnlyNumbers,
          value: _unref(store).tokensToPurchase,
          "data-testid": "tokens-number-input"
        }, null, 40, _hoisted_4),
        _createElementVNode("button", {
          class: "circle-button",
          type: "button",
          disabled: 
          _unref(store).tokensToPurchase >= _unref(store).maxNumberToPurchase && _unref(store).maxNumberToPurchase !== 0
        ,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(store).incrementTokensToPurchase && _unref(store).incrementTokensToPurchase(...args))),
          "data-testid": "increment-tokens-button"
        }, [
          _createVNode(_unref(PlusIcon))
        ], 8, _hoisted_5),
        (_unref(store).maxNumberToPurchase === 0 || _unref(store).maxNumberToPurchase > 100)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "absolute-side circle-button circle-button-small large-font",
              type: "button",
              onClick: plusTen
            }, " +10 "))
          : (_unref(store).tokensToPurchase !== _unref(store).maxNumberToPurchase)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "absolute-side circle-button circle-button-small",
                type: "button",
                disabled: _unref(store).maxNumberToPurchase <= 0,
                onClick: setPurchaseToMax
              }, " Max ", 8, _hoisted_6))
            : _createCommentVNode("", true)
      ])
    ]),
    (_unref(store).maxNumberToPurchase > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", null, "You can " + _toDisplayString(`${_unref(store).hasSecondary ? 'buy' : 'claim'}`) + " at most " + _toDisplayString(`${_unref(store).maxNumberToPurchase} ${_unref(pluralize)(_unref(store).maxNumberToPurchase, 'item')}`), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})